import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PolicyService } from '../../../../policy/services/policy.service';
import { AuthService } from '../../../../auth/services/auth.service';
import VehiclePolicy from '../../../../../core/data/models/vehicle.policy.model';
import { DecimalPipe } from '@angular/common';
import Policy from '../../../../../core/data/models/policy.mode';
import { FormsModule } from '@angular/forms';
import filterBy from '../../../../../common/functions/filterBy';

@Component({
    selector: 'app-vehicle-step',
    imports: [DecimalPipe, FormsModule],
    templateUrl: './vehicle-step.component.html',
    styleUrl: './vehicle-step.component.css'
})
export class VehicleStepComponent {
  vehiclePolicies: VehiclePolicy[] = [];
  filteredVehiclePolicies: VehiclePolicy[] = [];
  idNumber: string = '';
  @Input() showBackButton = true;
  @Output() onVehicleSelected = new EventEmitter<{
    policy: VehiclePolicy;
    unitNumber: number;
  }>();
  @Output() onGoBack = new EventEmitter<void>();

  searchFilter = '';

  constructor(
    private policyService: PolicyService,
    private authService: AuthService,
  ) {
    const user = this.authService.user;
    this.idNumber = user.idTokenClaims?.extension_IdNumber!;
  }

  @Input() set value(policy: Policy | null) {
    if (policy) {
      this.getVehicles(policy.policyNumber);
    }
  }

  getVehicles(policyNumber: string) {
    this.policyService
      .getVehiclePolicyDetail(policyNumber, this.idNumber)
      .subscribe((result) => {
        this.vehiclePolicies = result.data;
        this.filteredVehiclePolicies = result.data;
      });
  }

  selectVehicle(policy: VehiclePolicy, unitNumber: number) {
    this.onVehicleSelected.emit({ policy, unitNumber });
  }

  goBack() {
    this.onGoBack.emit();
  }

  handleSearch() {
    this.filteredVehiclePolicies = filterBy(
      this.vehiclePolicies,
      this.searchFilter,
      ['vehicleInfo.registrationNumber'],
    );
  }
}
